import { PlusOutlined } from '@ant-design/icons'
import { Typography } from 'antd'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import { getUserGroupByTeam } from '../../api/aops.api'
import {
  getApprovalList,
  getApprovalListForChief,
} from '../../api/electronicApproval.api'
import AopsHeader from '../../components/apos/AopsHeader'
import CaseTrackBoard from '../../components/apos/case/CaseTrackBoard'
import { isAopsChiefState, menuSelectedTeam } from '../../store/aops'
import { userAuthStatus, userState } from '../../store/user'
import ApprovalPopup from './component/ApprovalPopup'
import ApprovalProcess from './component/ApprovalProcess'
import ApprovalProcessForChief from './component/ApprovalProcessForChief'
import './electricApproval.scss'
const { Text, Title } = Typography

const ElectricApprovalPage = () => {
  const navigate = useNavigate()
  const [showDetailPopup, setShowDetailPopup] = useState(false)
  const [authStatus] = useRecoilState(userAuthStatus)
  const userTeamName = authStatus.teamName
  const [selectedTeam, setSelectedTeam] = useRecoilState(menuSelectedTeam)
  const [user] = useRecoilState(userState)
  const [proposalList, setProposalList] = useState([])
  const [fullProposalList, setFullProposalList] = useState([]) // API 원본 데이터 저장
  //VIEW, EDIT, REGISTER
  const [popupMode, setPopupMode] = useState('REGISTER')
  const [isChief, setIsChief] = useState(false)
  const [selectedApprovalId, setSelectedApprovalId] = useState(null)
  const [selectedApprovalStatus, setSelectedApprovalStatus] = useState(null)
  const [summary, setSummary] = useState(null)
  const [studioName, setStudioName] = useState(null)
  const [showAllStudioList, setShowAllStudioList] = useState(true)
  const [isAopsChief, setIsAopsChief] = useRecoilState(isAopsChiefState)
  const [chiefProposalList, setChiefProposalList] = useState([])

  useEffect(() => {
    if (!selectedTeam) return

    setShowAllStudioList(true)
    if (isAopsChief) {
      fetchChiefApprovalList()
      return
    } else {
      returnStudioName()
    }
  }, [selectedTeam, isAopsChief])

  // showAllStudioList 변경 시 필터링만 수행 (API 재호출 없음)
  useEffect(() => {
    if (fullProposalList.length === 0) return

    const filteredList = showAllStudioList
      ? fullProposalList
      : fullProposalList.filter((item) => item.createdBy === user.id)

    setProposalList(filteredList)
  }, [showAllStudioList, fullProposalList, user.id])
  // STROY :  Platform , Branding
  // TEAM :  DEVELOPMENT, PLANNING, BRANDING
  const returnStudioName = async () => {
    const _selectedTeam = selectedTeam?.toLowerCase()

    const res = await getUserGroupByTeam({ teamName: _selectedTeam })
    const studioName = res?.data?.studio
    setStudioName(studioName)
    await fetchApprovalList(studioName)
  }

  const fetchChiefApprovalList = async () => {
    try {
      const res = await getApprovalListForChief()
      console.log('getApprovalList::', res)
      setChiefProposalList(res ?? [])
    } catch (error) {
      console.log('error::', error)
      return
    }
  }

  const fetchApprovalList = async (studioName) => {
    const param = {
      salusUserId: user.id,
      studioName: studioName,
    }
    try {
      const res = await getApprovalList(param)
      console.log('getApprovalList::', res)

      // API 원본 데이터 저장
      const allProposals = res?.proposalInfos ?? []
      setFullProposalList(allProposals)

      // 현재 필터 상태에 따라 리스트 설정 (useEffect에서도 처리되지만 즉시 반영)
      const filteredList = showAllStudioList
        ? allProposals
        : allProposals.filter((item) => item.createdBy === user.id)
      setProposalList(filteredList)

      setIsChief(res?.isChief ?? false)
      setSummary(res?.proposalCountsByTeamNameKo ?? {})
    } catch (error) {
      console.log('error::', error)
      setFullProposalList([])
      setProposalList([])
      return
    }
  }

  const checkDisabledRegister = () => {
    const selected = selectedTeam?.toUpperCase()
    const userTeam = userTeamName?.toUpperCase()

    return selected !== userTeam
  }

  const disabledRegister = checkDisabledRegister()

  // refetchApprovalList wrapper - studioName을 자동으로 전달
  const refetchApprovalList = () => {
    if (studioName) {
      fetchApprovalList(studioName)
    }
  }

  return (
    <div
      style={{
        background: '#f9fafb',
        minHeight: '100vh',
        paddingBottom: '60px',
      }}
    >
      <AopsHeader active="electric-approval" />

      <div className="electric-approval-container">
        <section className="approval-header">
          <Title level={4} className="approval-title">
            기안서 결재 리스트
          </Title>
          {!isAopsChief && (
            <button
              disabled={disabledRegister}
              className={'register-button'}
              onClick={() => {
                setPopupMode('REGISTER')
                setShowDetailPopup(true)
              }}
            >
              기안서 등록
              <PlusOutlined style={{ marginLeft: '4px', fontWeight: `700` }} />
            </button>
          )}
        </section>
        {!isAopsChief && (
          <div className="filter-btn-group">
            <button
              disabled={showAllStudioList}
              className={`filter-btn ${showAllStudioList ? 'active-filter-btn' : ''}`}
              onClick={() => setShowAllStudioList(true)}
            >
              {studioName}
            </button>
            <button
              disabled={!showAllStudioList}
              className={`filter-btn ${!showAllStudioList ? 'active-filter-btn' : ''}`}
              onClick={() => {
                setShowAllStudioList(false)
              }}
            >
              {'개인'}
            </button>
          </div>
        )}
        {/* <ApprovalSummary
          summary={summary}
          studioName={returnStudioName()}
          isChief={isChief}
        /> */}
        {isAopsChief ? (
          <ApprovalProcessForChief
            proposalList={chiefProposalList}
            popupMode={popupMode}
            setPopupMode={setPopupMode}
            isChief={isAopsChief}
            setSelectedApprovalId={setSelectedApprovalId}
            setShowDetailPopup={setShowDetailPopup}
            refetchApprovalList={refetchApprovalList}
            setSelectedApprovalStatus={setSelectedApprovalStatus}
          />
        ) : (
          <ApprovalProcess
            proposalList={proposalList}
            popupMode={popupMode}
            setPopupMode={setPopupMode}
            isChief={isAopsChief}
            setSelectedApprovalId={setSelectedApprovalId}
            setShowDetailPopup={setShowDetailPopup}
            refetchApprovalList={refetchApprovalList}
            setSelectedApprovalStatus={setSelectedApprovalStatus}
          />
        )}
      </div>
      <ApprovalPopup
        open={showDetailPopup}
        onClose={() => setShowDetailPopup(false)}
        popupMode={popupMode}
        setPopupMode={setPopupMode}
        selectedApprovalId={selectedApprovalId}
        isChief={isAopsChief}
        selectedApprovalStatus={selectedApprovalStatus}
        refetchApprovalList={
          isAopsChief ? fetchChiefApprovalList : refetchApprovalList
        }
        setSelectedApprovalId={setSelectedApprovalId}
      />
    </div>
  )
}

export default ElectricApprovalPage
